import React from "react";
import { Building2 } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 2 (Family B) — Municipalities & Local Public Administrations
const Municipality = () => (
  <SolutionPageLayout
    testId="page-solution-municipality"
    icon={Building2}
    overline="Pathway · 02 of 07 · Aligned with Family B"
    title="For Municipalities & Local Public Administrations"
    headline="Clearer service coordination, citizen interaction, departmental visibility, document continuity, finance workflows, field operations, and management reporting."
    intro={[
      "For municipalities, local administrations, public-service organizations, local unions, and similar institutions that need clearer service coordination, citizen interaction, departmental visibility, document continuity, finance workflows, field operations, and management reporting.",
      "This pathway supports institutions that deliver public-facing services while managing internal administrative, financial, operational, and document-based responsibilities.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Citizen service and public desk workflows",
      "E-municipality and citizen-facing service access",
      "Municipal departments such as fire, municipal police, cleaning, parks, transportation, culture, sports, library, cemetery, marriage, veterinary, and related services",
      "Revenue, accrual, collection, and administrative finance workflows",
      "Zoning, licensing, address numbering, real estate, field, and infrastructure processes",
      "Document and records management",
      "Dashboards and management visibility",
    ]}
    ctaTitle="Bring municipal and public-service operations into a clearer digital structure."
    primaryCta={{ label: "Discuss Municipal Pathway", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#municipality-public-service-systems" }}
  />
);

export default Municipality;
